export default function IconLevelUp({ color = "white" }) {
  return (
    <div className="icon">
      <svg width="16px" height="16px" viewBox="0 0 16 16" fill="none">
        <path d="M16 6V5L11 0L6 5V6H10V12H1L1 14H12V6H16Z" fill={color} />
      </svg>
    </div>
  );
}
